<script setup lang="ts">
import type { ComponentStyles } from 'types/index';
import type { SpotManualData } from 'types/blocks';

defineProps<{
  data: SpotManualData;
  componentStyles?: ComponentStyles;
}>();
</script>

<template>
  <section>
    <BaseComponentWrapper
      :component-styles="componentStyles"
      class="no-margin-top no-margin-bottom"
    >
      <div class="container">
        <PartialsSpotManual :data="data" />
      </div>
    </BaseComponentWrapper>
  </section>
</template>
